import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lBmtU"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("iFlJw"), parcelRequire.load("9f8mp"), parcelRequire.load("7t2zJ"), parcelRequire.load("k5MRs")]).then(() => {
  return Promise.all([waitForCSS("https://reactspectrum.blob.core.windows.net/reactspectrum/76818701cc03367819306edb56c0799adf814789/s2-docs/error.90c2015a.css")]);
}).then(() => {
let originalModule = parcelRequire("jFoC3");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("iFlJw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("9f8mp")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lBmtU")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("7t2zJ")} />
  <link rel="modulepreload" href={parcelRequire.resolve("k5MRs")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
